import React from 'react';
import { BarChart3Icon, MessageCircleIcon } from 'lucide-react';
export const LaunchSection = () => {
  return <section className="rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-shadow duration-300" data-id="element-103">
      <div className="bg-gradient-to-r from-[#7FE5A8] to-[#5FD88F] py-6 px-8" data-id="element-104">
        <h2 className="text-2xl font-bold text-[#1A2332] flex items-center" data-id="element-105">
          <span className="inline-block h-11 w-11 rounded-xl bg-[#1A2332] text-[#7FE5A8] flex items-center justify-center mr-4 text-lg font-bold shadow-md" data-id="element-106">
            5
          </span>
          Launch
        </h2>
      </div>
      <div className="bg-white dark:bg-[#1A2332] p-10" data-id="element-107">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-108">
          <div data-id="element-109">
            <div className="flex items-center mb-7" data-id="element-110">
              <div className="h-10 w-10 rounded-xl bg-gradient-to-br from-[#7FE5A8] to-[#5FD88F] flex items-center justify-center mr-4 shadow-md" data-id="element-111">
                <BarChart3Icon className="h-5 w-5 text-[#1A2332]" data-id="element-112" />
              </div>
              <h3 className="text-xl font-semibold text-[#1A2332] dark:text-white" data-id="element-113">
                Success Metrics
              </h3>
            </div>
            <ul className="space-y-4" data-id="element-114">
              {['Adoption Rate (% completing Culture Check within 30 days)', 'Engagement Rate (active leaders per week)', 'Retention Rate (renewal post-MVP)', 'ROI Improvement (turnover & burnout reduction)', 'NPS (leadership satisfaction)'].map((metric, index) => <li key={index} className="flex items-start bg-[#E8FAF1] dark:bg-[#2A3F5F] p-4 rounded-xl hover:bg-[#d5f5e8] dark:hover:bg-[#344A66] hover:scale-[1.02] transition-all duration-200" data-id="element-115">
                  <div className="h-8 w-8 rounded-lg bg-[#7FE5A8] flex items-center justify-center text-[#1A2332] mr-4 mt-0.5 text-sm font-bold flex-shrink-0 shadow-sm" data-id="element-116">
                    {index + 1}
                  </div>
                  <span className="text-[#1A2332] dark:text-white font-medium leading-relaxed" data-id="element-117">
                    {metric}
                  </span>
                </li>)}
            </ul>
          </div>
          <div data-id="element-118">
            <div className="flex items-center mb-7" data-id="element-119">
              <div className="h-10 w-10 rounded-xl bg-gradient-to-br from-[#1A2332] to-[#2A3F5F] flex items-center justify-center mr-4 shadow-md" data-id="element-120">
                <MessageCircleIcon className="h-5 w-5 text-white" data-id="element-121" />
              </div>
              <h3 className="text-xl font-semibold text-[#1A2332] dark:text-white" data-id="element-122">
                Feedback Loops
              </h3>
            </div>
            <ul className="space-y-4" data-id="element-123">
              {['Executive feedback: ROI & usability', 'Manager feedback: engagement & usability', 'Coach/Therapist feedback: client alignment', 'Team feedback: sentiment & collaboration'].map((feedback, index) => <li key={index} className="flex items-start bg-[#2A3F5F] dark:bg-[#344A66] p-4 rounded-xl hover:bg-[#344A66] dark:hover:bg-[#3D5270] hover:scale-[1.02] transition-all duration-200" data-id="element-124">
                  <div className="h-8 w-8 rounded-lg bg-[#7FE5A8] flex items-center justify-center text-[#1A2332] mr-4 mt-0.5 text-sm font-bold flex-shrink-0 shadow-sm" data-id="element-125">
                    {index + 1}
                  </div>
                  <span className="text-white font-medium leading-relaxed" data-id="element-126">
                    {feedback}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
};